import { render, staticRenderFns } from "./weeklySpending.vue?vue&type=template&id=3a5976a7&scoped=true"
import script from "./weeklySpending.vue?vue&type=script&lang=js"
export * from "./weeklySpending.vue?vue&type=script&lang=js"
import style0 from "./weeklySpending.vue?vue&type=style&index=0&id=3a5976a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5976a7",
  null
  
)

export default component.exports